import { useState } from 'react'

import { AutoEnrollmentContract } from '@/AutoEnrollment/application'
import { AutoEnrollmentRepository } from '@/AutoEnrollment/domain'
import { useLoader } from '@/Shared/ui/loader'

interface CheckedCif {
  cif: string
  alreadyExists: boolean
}

export interface IUseCheckCifAlreadyExists {
  checkCif: (value: string) => Promise<boolean>
  currentCheckedCif: CheckedCif
}

export const useCheckCifAlreadyExists = (
  repository: AutoEnrollmentRepository,
): IUseCheckCifAlreadyExists => {
  const { startLoading, stopLoading } = useLoader()

  const [currentCheckedCif, setCurrentCheckedCif] = useState<CheckedCif>({
    cif: '',
    alreadyExists: false,
  })

  const checkCif = async (cif: string): Promise<boolean> => {
    startLoading()

    const response = await AutoEnrollmentContract(repository).checkCifAlreadyExists(cif)

    stopLoading()

    const alreadyExists = response.data ?? false

    setCurrentCheckedCif({
      cif,
      alreadyExists,
    })

    return alreadyExists
  }

  return {
    checkCif,
    currentCheckedCif,
  }
}
